import type { FaireProductEntity } from "../../entity_types/product";

export const p_qd2d3ntp4w: FaireProductEntity = {
  token: "p_qd2d3ntp4w",
  type: "product",
  name: "Arizona Real Sugar PET Green Tea 20/16.9OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/7bde2295746c6fb50e6e84b922ce0b0e40463a1030d3754f85416480d5ab072c.jpeg",
  galleryImageUrls: [],
  priceDollars: 40.18,
  description:
    "Indulge in the authentic flavor of L&F Universal Goods' Real Sugar PET Green Tea. This 20/16.9OZ delight features our signature green tea, sweetened naturally for a balanced and refreshing taste. Perfect for any time of the day, it offers a satisfying flavor. Savor the moment with this irresistible beverage from L&F Universal Goods.",
  tags: [],
  msrpDollars: 78.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:16.584Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
